import { FC, useCallback } from 'react';
import { useField } from 'formik';
import {
  DatePicker as MuiDatePicker,
  DatePickerProps,
} from '@mui/x-date-pickers/DatePicker';

import TextField from '@mui/material/TextField';

type Props = Omit<
  DatePickerProps<Date, Date>,
  'value' | 'onChange' | 'renderInput'
> & {
  name: string;
  fullWidth?: boolean;
};

const DatePicker: FC<Props> = ({ name, fullWidth, ...rest }) => {
  const [{ value }, meta, { setValue }] = useField<Date | null>(name);

  const handleChange = useCallback(
    (value: Date | null) => {
      setValue(value);
    },
    [setValue]
  );

  return (
    <MuiDatePicker
      showDaysOutsideCurrentMonth
      inputFormat="yyyy-MM-dd"
      mask="____-__-__"
      value={value}
      onChange={handleChange}
      renderInput={params => (
        <TextField
          {...params}
          error={Boolean(meta.touched && meta.error)}
          helperText={meta.touched && meta.error}
          fullWidth={fullWidth}
          variant="standard"
        />
      )}
      {...rest}
    />
  );
};

export default DatePicker;
